import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import ClassSchedule from './ClassSchedule';
import { veryLittleAngelClassSchedule } from '../../util/constants';

const VeryLittleAngelClassSchedule = props => {
  const styles = {
    title: {
      marginTop: 20,
      textAlign: 'center',
      marginBottom: 10
    },
    veryLittleAngelClassSchedule: {
      marginBottom: 20,
      textAlign: 'center'
    }
  }

  return (
    <Grid
      constainer
      direction='row'
      justifyContent='center'
    >
      <Grid
        item
        xs={12}
      >
        <Typography
          variant="h5"
          component="div"
          style={styles.title}
        >
          親子兒童讀經班
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        style={styles.veryLittleAngelClassSchedule}
      >
        <Grid
          container
          direction='row'
          justifyContent='center'
        >
          {
            veryLittleAngelClassSchedule.map((theClass, i) => {
              return (
                <React.Fragment>
                  <Grid item xs={1} sm={2}></Grid>
                  <Grid
                    item
                    xs={10}
                    sm={8}
                    style={styles.veryLittleAngelClassSchedule}
                  >
                    <ClassSchedule theClass={theClass} />
                  </Grid>
                  <Grid item xs={1} sm={2}></Grid>
                </React.Fragment>
              )
            })
          }
        </Grid>
      </Grid>
      
    </Grid>
  )
}

export default VeryLittleAngelClassSchedule;